import React from "react";

const Android = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M27.27 26.256a1.3 1.3 0 01-1.301 1.303h-15.06a1.302 1.302 0 01-1.3-1.303V12.802c3.947-.014 13.156-.014 17.66 0v13.454zM15.187 5.904a.301.301 0 01-.13.404.301.301 0 01-.403-.13l-1.903-3.711a.3.3 0 01.534-.273l1.902 3.71zM22.12 6.06a.297.297 0 01-.41.108.296.296 0 01-.108-.408l2.085-3.61a.298.298 0 01.409-.109.298.298 0 01.11.408L22.12 6.06zM31.867 22.608a1.897 1.897 0 01-3.794 0v-8.297c0-1.049.849-1.896 1.898-1.896 1.047 0 1.896.847 1.896 1.896v8.297zM8.793 22.608a1.897 1.897 0 01-3.793 0v-8.297a1.895 1.895 0 113.793 0v8.297z"
              fill={fill}/>
        <path className="u_fill"
              d="M17.05 32.104a1.897 1.897 0 01-3.793 0v-8.297a1.897 1.897 0 113.792 0v8.297zM23.627 32.104a1.897 1.897 0 01-3.794 0v-8.297a1.898 1.898 0 013.794 0v8.297zM18.44 3.936c-4.613 0-8.411 3.51-8.919 8.022h17.836c-.507-4.512-4.303-8.022-8.918-8.022zM14.414 8.8a.741.741 0 11-.004-1.482.741.741 0 01.004 1.482zm8.064 0a.741.741 0 11-.003-1.482.741.741 0 01.003 1.482z"
              fill={fill}/>
    </svg>
);

export default Android;
